import * as React from 'react';

import { CertificateIcon, DegreeIcon, ReadingIcon } from '@coursera/cds-icons';

type Props = {
  iconName?: string | null;
  size?: 'large' | 'medium' | 'small';
};

const ValuePropositionIcon = ({ iconName, size = 'large' }: Props) => {
  switch (iconName) {
    case 'CertificateIcon':
      return <CertificateIcon size={size} />;
    case 'DegreeIcon':
      return <DegreeIcon size={size} />;
    default:
      return <ReadingIcon size={size} />;
  }
};

export default ValuePropositionIcon;
